import React from "react";
import MfdChart, { MfdTableMeta, Series } from "../common/MfdChart";

interface GeneralViewMfdProps {
  mfdTableMeta: MfdTableMeta | undefined;
  parentWidth: number;
  series: Series[];
  cumulative: boolean;
}

/**
 * Draws a pre-parsed MFD series at the width supplied by the surrounding
 * `ParentSize`. The table query and the parsing live in
 * `GeneralViewMfdDynamicDialog`, which needs to know whether there is any data
 * before it decides to render a chart at all.
 */
const GeneralViewMfd: React.FC<GeneralViewMfdProps> = ({
  mfdTableMeta,
  parentWidth,
  series,
  cumulative,
}: GeneralViewMfdProps) => {
  return (
    <div style={{ position: "relative", width: "100%" }}>
      {mfdTableMeta && (
        <MfdChart
          series={series}
          mfdTableMeta={mfdTableMeta}
          width={parentWidth}
          title={cumulative ? "Cumulative MFDs" : "Incremental MFDs"}
        />
      )}
    </div>
  );
};

export default GeneralViewMfd;
